import React from 'react'
import AutoTable from './design-components/AutoTable';

interface FutureImpactProps {
    tableData: any;
    title: string;
    tableTitle: string;
    interpretations:any
}


const FutureImpact = ({
    tableData,
    title,
    tableTitle,
    interpretations
}: FutureImpactProps
) => {
    const Interpretations = [
        {label:"A" ,desc:"Precision Medicine Biomarker Analysis and Symptom Monitoring & Side Effect Triage represent the highest strategic opportunities due to their potential to significantly improve patient outcomes and personalized treatment plans."},
        {label:"B" ,desc:"Clinical Trial Matching & Eligibility Screening and Treatment Decision Support have moderate strategic value but face infrastructure and readiness gaps that need to be addressed for widespread adoption."},
        {label:"C" ,desc:"Stakeholders show high enthusiasm for Precision Medicine Biomarker Analysis and Symptom Monitoring & Side Effect Triage, indicating these functions are highly desired in the healthcare domain."},
        {label:"D" ,desc:"Workflow Automation for Documentation is ready for near-term adoption due to high infrastructure readiness, but it may not have as high a strategic value as other functions."},
        {label:"E" ,desc:"Functions like Prognosis Prediction & Risk Modeling and Medical Jargon Translation / Patient Education are likely to become standard practice in the near future due to their balanced scores across all dimensions."},
        {label:"F" ,desc:"Care Coordination & Navigation Support needs more development to increase stakeholder enthusiasm and readiness for adoption, despite its moderate strategic value."}
        
    ];
    return (
        <div className="flex flex-col h-full items-center">
            <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-2 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">
                {title}
            </h1>
            <div className='grid grid-cols-2 gap-4'>
               <AutoTable data={tableData} title={tableTitle} />
               <div className='flex flex-col gap-2'>
                <h2 className="text-black text-center font-extrabold max-w-4xl text-xl lg:text-2xl font-nunito">Interpretations</h2>
                <div className='border-2 border-green-400 rounded-lg p-1 space-y-1'>
                    {interpretations.interpretations.map((item:any) => (
                        <div key={item.label} className="p-2 bg-[#7db245] rounded-lg">
                            <span className="font-bold text-sm">{item.label}:</span> <span className='text-sm'>{item.interpretation}</span> 
                        </div>
                    ))}
                </div>

               </div>
                
            </div>
            

        </div>
    )
}

export default FutureImpact
